import $ from 'jquery';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');


$('.accordion').each(function () {

    if (inBackend) return;

    const $element = $(this);
    const $items = $element.find('.accordion-item');

    $items.each(function () {

        const $item = $(this);
        const $button = $item.find('.accordion-header');
        const $content = $item.find('.accordion-collapse');

        // Initially hide content
        $content.hide();
        $item.addClass('collapsed');

        $button.on('click', function () {
            $item.toggleClass('collapsed');
            $content.slideToggle();
        });

    });


});
